var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#44546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25C32.7956 25 33.5587 25.3161 34.1213 25.8787C34.6839 26.4413 35 27.2044 35 28H25V30H34.92C34.814 30.68 34.598 31.356 34.28 32H25V34H32.858C31.146 35.766 28.462 37 25 37C18.72 37 15 32.942 15 29V28C15 27.2044 15.3161 26.4413 15.8787 25.8787C16.4413 25.3161 17.2044 25 18 25H32ZM30.41 16.5C30.53 17.1613 30.53 17.8387 30.41 18.5H25V20.5H29.61C28.9633 21.4937 28.0128 22.2519 26.9001 22.6614C25.7874 23.071 24.5722 23.11 23.4356 22.7727C22.2989 22.4355 21.3017 21.7399 20.5925 20.7897C19.8834 19.8395 19.5002 18.6856 19.5002 17.5C19.5002 16.3144 19.8834 15.1605 20.5925 14.2103C21.3017 13.2601 22.2989 12.5645 23.4356 12.2273C24.5722 11.89 25.7874 11.929 26.9001 12.3386C28.0128 12.7481 28.9633 13.5063 29.61 14.5H25V16.5H30.41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.0d2a51bec6720ec2874a52fd3d6327d0.svg";
export { ForwardRef as ReactComponent };